import { ApplicationEnvironmentEnum } from '@zaoblako/shared/common/enums/application-environment.enum';
import { TelegramBotFindDto, type TelegramBotFindInterface } from '@zaoblako/shared/modules/integration/dtos/telegram-bot/telegram-bot-find.dto';
import {
  Speech2TextRuAccountFindDto,
  type Speech2TextRuAccountFindInterface,
} from '@zaoblako/shared/modules/integration/dtos/speech-2-text-ru-account/speech-2-text-ru-account-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';

import * as yup from 'yup';

/** FRM instance response body - DTO signature */
export interface FrmInstanceFindInterface {
  /** Unique identifier (UUID). Cannot be changed. */
  id: string;

  // Tech columns
  /** Instance creation date and time */
  created: Date;
  /** Instance last update date and time */
  updated: Date;
  /** Instance soft delete date and time */
  deleted?: Date;

  // Data columns
  /** Instance display name */
  name: string;
  /** Instance environment */
  environment: ApplicationEnvironmentEnum;
  /** Instance version */
  version: string;
  /** Instance address in `gRPC` format (`ipv4:///<host>[:port],<host>[:port],...`) */
  address: string;
  /** Telegram bot of the instance */
  telegramBot: TelegramBotFindInterface;
  /**
   * {@link https://speech2text.ru "Speech2Text"} account to use.
   * If not defined then default account will be used.
   */
  speech2TextRuAccount?: Speech2TextRuAccountFindInterface;
}

/** FRM instance response body - DTO schema */
export const FrmInstanceFindDto = SerdeDtoClass.create<FrmInstanceFindInterface>(SaasDtoKeysEnum.FRM_INSTANCE_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  environment: {
    label: 'Окружение',
    serializer: yup
      .string()
      .oneOf(Object.values(ApplicationEnvironmentEnum)),
  },
  version: {
    sortable: true,
    label: 'Версия',
    serializer: yup.string(),
  },
  address: {
    sortable: true,
    label: 'Адрес',
    serializer: yup.string(),
  },
  telegramBot: {
    sortable: true,
    label: 'Telegram-бот',
    nested: TelegramBotFindDto,
    serializer: (_, nested) => nested,
  },
  speech2TextRuAccount: {
    optional: true,
    sortable: true,
    label: 'Аккаунт "Speech2Text"',
    nested: Speech2TextRuAccountFindDto,
    serializer: (_, nested) => nested,
  },
});
